/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { InvalidContext } from "cms/common/errors/invalid-context.error";
import { useContext } from "react";
import { FormContext } from "../form-context";

export function useFormContext () {

    const context = useContext(FormContext);

    if (!context) {
        throw new InvalidContext("FormContext", "FormProvider");
    }

    return context;
}

